import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	mondayHeading: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-heading',
		defaultMessage: 'monday hierarchy',
		description: 'Heading of monday hierarchy - Do not translate "monday" it is the product name.',
	},
	jiraHeadingSpork: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-heading-spork',
		defaultMessage: 'Jira hierarchy',
		description: 'Heading of Jira hierarchy',
	},
	illustrationLabel: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.illustration-label',
		defaultMessage: 'Map monday project to Jira project',
		description: 'Accessible label for the illustration in project hierarchy',
	},
	mondayGroup: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-group',
		defaultMessage: 'Group',
		description: 'text of Monday Group',
	},
	mondayItem: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-item',
		defaultMessage: 'Item',
		description: 'text of Monday Item',
	},
	mondaySubitem: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-subitem',
		defaultMessage: 'Subitem',
		description: 'text of Monday Subitem',
	},
	jiraEpic: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-epic',
		defaultMessage: 'Epic',
		description: 'text of Jira Epic',
	},
	jiraTask: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-task',
		defaultMessage: 'Task',
		description: 'text of Jira Task',
	},
	jiraSubtask: {
		id: 'project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-subtask',
		defaultMessage: 'Subtask',
		description: 'text of Jira Subtask',
	},
});
